import { Vegobjekttype } from '@/domain/vegobjekter/Vegobjekttype';
import { Stedsnavn, StedsnavnResponse } from '@/server/responses';
import { Fylke, Kommune, Kontraktsomrade, Land, Riksvegrute } from '@/domain/omrader';
import { Vegkategori } from '@/domain/Vegkategori';
import { DropdownItemData } from '@/components/avgrensning/search/dropdown/DropdownItem';

export type DropdownObject =
    | Land
    | Fylke
    | Kommune
    | Riksvegrute
    | Kontraktsomrade
    | Vegkategori
    | Vegobjekttype
    | Stedsnavn;

export class SearchState {
    constructor(
        readonly recentSearchQueries: DropdownItemData[] = JSON.parse(
            localStorage.getItem('recentSearchQueries') || '[]'
        ),
        readonly searchDropdownState: SearchDropdownState = new SearchDropdownState(),
        readonly placeNames: StedsnavnResponse | null = null,
        // Mobile
        readonly filterPanelOpen: boolean = false,
        readonly searchPanelOpen: boolean = false
    ) {}

    override(modifyObject: { [P in keyof SearchState]?: SearchState[P] }): SearchState {
        return Object.assign(Object.create(SearchState.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withRecentSearchQueries(searchQuery: DropdownItemData): SearchState {
        return this.override({
            recentSearchQueries: createListOfRecentSearchQueries(
                searchQuery,
                this.recentSearchQueries
            ),
        });
    }

    withDropdownState(searchDropdownState: SearchDropdownState): SearchState {
        return this.override({ searchDropdownState });
    }

    withPlaceNames(placeNames: StedsnavnResponse): SearchState {
        return this.override({ placeNames });
    }

    withFilterPanelOpen(filterPanelOpen: boolean): SearchState {
        return this.override({ filterPanelOpen });
    }

    withSearchPanelOpen(searchPanelOpen: boolean): SearchState {
        return this.override({ searchPanelOpen });
    }
}

export class SearchDropdownState {
    constructor(
        readonly datakatalogOpen: boolean = false,
        readonly searchText: string = '',
        readonly timestamp: Date | null = null
    ) {}

    override(modifyObject: {
        [P in keyof SearchDropdownState]?: SearchDropdownState[P];
    }): SearchDropdownState {
        return Object.assign(Object.create(SearchDropdownState.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withDatakatalogOpen(datakatalogOpen: boolean) {
        return this.override({ datakatalogOpen });
    }

    withSearchText(searchText: string) {
        return this.override({ searchText });
    }

    withTimestamp(timestamp: Date | null) {
        return this.override({ timestamp });
    }
}

export const createListOfRecentSearchQueries = (
    newSearchQuery: DropdownItemData,
    recentSearchQueries: DropdownItemData[]
): DropdownItemData[] => {
    return [
        { title: 'Nylige søk', header: true, disabled: true },
        newSearchQuery,
        ...recentSearchQueries.filter(
            (r: DropdownItemData) =>
                !r.header &&
                (r.title !== newSearchQuery.title ||
                    (r.title === 'Polygonsøk' && r.subtitle !== newSearchQuery.subtitle))
        ),
    ].slice(0, 100);
};
